import {
  DocumentTypeConfig,
  DocumentTypes,
  StepOptionDocument,
} from '~types/steps'
import { filterDocumentSelection } from './useDocumentTypesAdapter'

// This is a weird requirement, we dont know why it's there but we're afraid to change it so we're keeping it.
const shouldSkipSelectionStepIfSingleDocument = (
  documentTypes: Partial<Record<DocumentTypes, DocumentTypeConfig>>
) => {
  const documentTypesKeys = Object.keys(documentTypes) as DocumentTypes[]
  let documentTypeCount = 0
  documentTypesKeys.forEach((type) => {
    if (documentTypes[type]) {
      documentTypeCount++
    }
  })
  return documentTypeCount === 1
}

export const showRestrictedDocumentSelectionStep = (
  options: StepOptionDocument | undefined
): boolean => {
  if (!options?.documentTypes) {
    return true
  }
  if (shouldSkipSelectionStepIfSingleDocument(options.documentTypes)) {
    return false
  }

  const selection = filterDocumentSelection(options?.documentTypes)

  if (selection.length === 1) {
    // we get a single country, and a single document type.
    return false
  }

  // all other cases
  return true
}
